import React from 'react';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import {withStyles} from '@material-ui/core/styles';
import Done from '@material-ui/icons/Done';

const styles = theme => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        // minWidth: 700,
    }
});

const AssessmentReviewerTable = (props) => {
    const renderRow = (user) => {
        let reviewed = null;
        if(user.finished) {
            reviewed = <Done/>
        }
        return (
            <TableRow key={user.unid}>
                <TableCell>{user.display_name}</TableCell>
                <TableCell>{user.unid}</TableCell>
                <TableCell>
                    {reviewed}
                </TableCell>
            </TableRow>
        )
    };

    const rows = props.users.map((user) => renderRow(user));
        return (
            <Paper className={props.classes.root}>
                <Table className={props.classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>uNID</TableCell>
                            <TableCell>Completed</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows}
                    </TableBody>
                </Table>
            </Paper>
        )
};

export default withStyles(styles)(AssessmentReviewerTable);